import {Component} from "react";
import React from "react";
import styled from 'styled-components/macro';
import PropTypes from "prop-types";
import EnvimationIcon from "../../../../shared-components/EnvimationIcon/EnvimationIcon";
import breakpoint from "styled-components-breakpoint";

const CollapsibleAreaWrapper = styled.span.attrs(props => ({
    className: props.className
}))`
    &:hover {
        cursor: pointer;
    }
    vertical-align: super;
`;

const CollapseIcon = styled(EnvimationIcon).attrs(props => ({
    iconElement: props.clicked ? "comment-lines" : "comment" ,
    className: props.className,
    title: props.clicked ? "Open " + props.title : "Close "+props.title ,
    iconStyle: "light",
    size: '1x'
}))`
`;

const Title = styled.span`
    vertical-align: super;
    color: blue
`;
const Content = styled.div`
  ${props => props.clicked && `
        display: none;
    `};
    ${breakpoint('md')`
        padding-left: 2rem;
    `}
    
    padding-top: 2rem;
    padding-bottom: 2rem;
    font-size: 0.9em;
`;

class CollapsibleArea extends Component {
    constructor(props) {
        super(props);
        this.state = {clicked: true}
    }

    clickHandler = () => {
        this.setState({clicked: !this.state.clicked});
    };

    render() {
            return (
                <CollapsibleAreaWrapper className={this.props.className}  clicked={this.state.clicked}>
                    <Title onClick={this.clickHandler}><CollapseIcon title={this.props.title} clicked={this.state.clicked}/></Title>
                    <Content clicked={this.state.clicked}>{this.props.children}</Content>
                </CollapsibleAreaWrapper>
            )
    }
}


CollapsibleArea.defaultProps = {
};

CollapsibleArea.propTypes = {
    title: PropTypes.string.isRequired
};

export default CollapsibleArea;
